import { Pipe, PipeTransform } from '@angular/core';

import { AlertType } from '@domain/alerting/alerting.enums';

import { TranslateEnumPipeBase } from '@shared/pipes/translate-enum-pipe-base';

const KEY_PREFIX = 'enums.alert-type';
export const AlertTypeKeyMapping: Record<AlertType, string> = {
  [AlertType.DEVICE_FLAKY_CONNECTION_ALERT]: `${KEY_PREFIX}.device-flaky-connection-alert`,
  [AlertType.FLAKY_MGC_CONNECTION]: `${KEY_PREFIX}.flaky-mgc-connection`,
  [AlertType.CHARGER_COMMS_SLOW_ALERT]: `${KEY_PREFIX}.charger-comms-slow-alert`,
  [AlertType.DEVICE_COMMS_TIMEOUT_ALERT]: `${KEY_PREFIX}.device-comms-timeout-alert`,
  [AlertType.CHARGER_OFFLINE_ALERT]: `${KEY_PREFIX}.charger-offline-alert`,
  [AlertType.ALL_CHARGERS_OFFLINE_ALERT]: `${KEY_PREFIX}.all-chargers-offline-alert`,
  [AlertType.CHARGER_CRITICAL_HARDWARE_FAULT]: `${KEY_PREFIX}.charger-critical-hardware-fault`,
  [AlertType.CHARGER_CRITICAL_VEHICLE_FAULT]: `${KEY_PREFIX}.charger-critical-vehicle-fault`,
  [AlertType.CHARGER_CRITICAL_OPERATIONAL_FAULT]: `${KEY_PREFIX}.charger-critical-operational-fault`,
  [AlertType.CHARGER_CRITICAL_CONNECTIVITY_FAULT]: `${KEY_PREFIX}.charger-critical-connectivity-fault`,
  [AlertType.CHARGER_NON_CRITICAL_HARDWARE_FAULT]: `${KEY_PREFIX}.charger-non-critical-hardware-fault`,
  [AlertType.CHARGER_NON_CRITICAL_VEHICLE_FAULT]: `${KEY_PREFIX}.charger-non-critical-vehicle-fault`,
  [AlertType.CHARGER_NON_CRITICAL_OPERATIONAL_FAULT]: `${KEY_PREFIX}.charger-non-critical-operational-fault`,
  [AlertType.CHARGER_NON_CRITICAL_CONNECTIVITY_FAULT]: `${KEY_PREFIX}.charger-non-critical-connectivity-fault`,
  [AlertType.CHARGER_UNCATEGORIZED_FAULT]: `${KEY_PREFIX}.charger-uncategorized-fault`,
  [AlertType.DEVICE_OFFLINE_ALERT]: `${KEY_PREFIX}.device-offline-alert`,
  [AlertType.CHARGER_FLAKY_CONNECTION_ALERT]: `${KEY_PREFIX}.charger-flaky-connection-alert`,
  [AlertType.CHARGER_COMMS_TIMEOUT_ALERT]: `${KEY_PREFIX}.charger-comms-timeout-alert`,
  [AlertType.POSSIBLE_BREAKER_TRIP_ALERT]: `${KEY_PREFIX}.possible-breaker-trip-alert`,
  [AlertType.MGC_TEMPORARILY_OFFLINE_ALERT]: `${KEY_PREFIX}.mgc-temporarily-offline-alert`,
  [AlertType.EVSE_FAULTED_ALERT]: `${KEY_PREFIX}.evse-faulted-alert`,
  [AlertType.EVSE_OCCUPIED_WITHOUT_TRANSACTION_ALERT]: `${KEY_PREFIX}.evse-occupied-without-transaction-alert`,
  [AlertType.GRID_LIMIT_BREACHED]: `${KEY_PREFIX}.grid-limit-breached`,
  [AlertType.DISPATCH_INITIATED]: `${KEY_PREFIX}.dispatch-initiated`,
  [AlertType.OPTIMIZATION_UNABLE_TO_SATISFY_CHARGING_REQUIREMENTS]: `${KEY_PREFIX}.optimization-unable-to-satisfy-charging-requirements`,
  [AlertType.OPTIMATOR_LOAD_PROFILE_STALE_ALERT]: `${KEY_PREFIX}.optimator-load-profile-stale-alert`,
  [AlertType.POWER_DROPPED_TO_ZERO]: `${KEY_PREFIX}.power-dropped-to-zero`,
  [AlertType.POWER_DROPPED_TO_ZERO_AT_BATTERY_PACK_SOC_POINT]: `${KEY_PREFIX}.power-dropped-to-zero-at-battery-pack-soc-point`,
  [AlertType.POWER_DROPPED_TO_2KW]: `${KEY_PREFIX}.power-dropped-to-2kw`,
  [AlertType.MASS_AUTHORIZATION_ERRORS]: `${KEY_PREFIX}.mass-authorization-errors`,
  [AlertType.REPEATED_EVSE_TRANSACTION_START_ISSUES]: `${KEY_PREFIX}.repeated-evse-transaction-start-issues`,
  [AlertType.REPEATED_VEHICLE_TRANSACTION_START_ISSUES]: `${KEY_PREFIX}.repeated-vehicle-transaction-start-issues`,
  [AlertType.VEHICLE_NO_TELEMATICS]: `${KEY_PREFIX}.vehicle-no-telematics`,
  [AlertType.MULTIPLE_VEHICLES_NO_TELEMATICS]: `${KEY_PREFIX}.multiple-vehicles-no-telematics`,
  [AlertType.POWER_LIMIT_CHANGE_REJECTED]: `${KEY_PREFIX}.power-limit-change-rejected`,
};

@Pipe({
  name: 'appTranslateAlertType',
  pure: false,
  standalone: true,
})
export class TranslateAlertTypePipe extends TranslateEnumPipeBase<AlertType> implements PipeTransform {
  protected readonly valueTranslateKeyMap = AlertTypeKeyMapping;
}
